module.exports = __webpack_public_path__ + "963a8e15419c4fa616d635641850fb8d.png";